export * from './general.actions';

export {
  featureKey as generalFlowDataKey,
  initialState as generalFlowDataInitialState,
  State as GeneralFlowDataState,
  generalReducer,
} from './general.reducer';

export * from './general.selectors';
